import { render, staticRenderFns } from "./Garis.vue?vue&type=template&id=c9f25244"
import script from "./Garis.vue?vue&type=script&lang=js"
export * from "./Garis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports